import 'zone.js';
import { bootstrapApplication } from '@angular/platform-browser';
import { APP_INITIALIZER, LOCALE_ID, importProvidersFrom } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeFrExtra from '@angular/common/locales/extra/fr';
import { AppComponent } from './app/app.component';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app/app.routes';
import { authInterceptor } from './app/core/auth/auth.interceptor';
import { VersionService } from './app/core/services/version.service';
import {
  LucideAngularModule,
  // Icônes du design system (alignées sur EMOJI_TO_LUCIDE).
  // Ajouter ici toute nouvelle icône utilisée via <app-icon>.
  AlertCircle, AlertOctagon, AlertTriangle, Archive, ArrowLeft, ArrowRight, ArrowUpDown, Barcode, BarChart3, BellRing, BookOpen, Brush, Building2, Calendar, CalendarDays, Car,
  Camera, Check, CheckCircle, CheckCircle2, ChevronDown, ChevronLeft, ChevronRight, ChevronUp, CircleDashed, CircleDot, CirclePlus, ClipboardList,
  Clock, CloudFog, Construction, Copy, CornerDownRight, Crown, DoorClosed, Download, Eye, EyeOff, Factory, FileDown, FileOutput, FileText, Filter, Flame, FlaskConical, Folder, FolderOpen,
  CreditCard, Fuel, GitMerge, Globe, Hand, HardHat, HeartPulse, HelpCircle, History, Home, Image, Inbox, Info, Key, Keyboard, KeyRound, LayoutDashboard, LayoutGrid, LayoutList, Leaf, Library, Link2, List, Loader2, Lock, LogOut, Mail, MapPin, Megaphone, MessageCircle, MessageSquare, MessagesSquare, Mic, MicOff,
  Moon, MoreVertical, Package, Pencil, PencilLine, PenTool, Pin, PlugZap, Play, Plus, Pause, RefreshCcw, RefreshCw, Ruler, Save, Scale, Search, Send, Settings, ShoppingCart,
  ShieldCheck, Sparkles, Square, Star, Stethoscope, Sun, Target, Thermometer, TrendingUp, Trash2, Truck, Undo2, Unlock, Upload,
  User, UserPlus, Users, Volume2, VolumeX, Wifi, Wrench, X, Zap,
  // Retours SSE 09/2026 : vérifications périodiques, plan d'actions, FDS, accueil SSE
  Anchor, Ban, Bell, BriefcaseMedical, Cable, CalendarClock, CircleCheck, ClipboardCheck, ClipboardPen, Cog, DoorOpen, DraftingCompass, ExternalLink,
  FileCheck, FileSearch, FileSpreadsheet, Gauge, Hourglass, Lightbulb, ListChecks, QrCode, Paperclip, ScanBarcode, ScanLine, ShieldAlert, Siren,
} from 'lucide-angular';

registerLocaleData(localeFr, 'fr-FR', localeFrExtra);

bootstrapApplication(AppComponent, {
  providers: [
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    // Chaque nouvelle page s'ouvre en haut (Safari iPhone gardait la position de l'accueil) ;
    // le retour arrière retrouve la position précédente.
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })),
    provideHttpClient(
      withInterceptors([authInterceptor])
    ),
    importProvidersFrom(
      LucideAngularModule.pick({
        AlertCircle, AlertOctagon, AlertTriangle, Archive, ArrowLeft, ArrowRight, ArrowUpDown, Barcode, BarChart3, BellRing, BookOpen, Brush, Building2, Calendar, CalendarDays, Car,
        Camera, Check, CheckCircle, CheckCircle2, ChevronDown, ChevronLeft, ChevronRight, ChevronUp, CircleDashed, CircleDot, CirclePlus, ClipboardList,
        Clock, CloudFog, Construction, Copy, CornerDownRight, Crown, DoorClosed, Download, Eye, EyeOff, Factory, FileDown, FileOutput, FileText, Filter, Flame, FlaskConical, Folder, FolderOpen,
        CreditCard, Fuel, GitMerge, Globe, Hand, HardHat, HeartPulse, HelpCircle, History, Home, Image, Inbox, Info, Key, Keyboard, KeyRound, LayoutDashboard, LayoutGrid, LayoutList, Leaf, Library, Link2, List, Loader2, Lock, LogOut, Mail, MapPin, Megaphone, MessageCircle, MessageSquare, MessagesSquare, Mic, MicOff,
        Moon, MoreVertical, Package, Pencil, PencilLine, PenTool, Pin, PlugZap, Play, Plus, Pause, RefreshCcw, RefreshCw, Ruler, Save, Scale, Search, Send, Settings, ShoppingCart,
        ShieldCheck, Sparkles, Square, Star, Stethoscope, Sun, Target, Thermometer, TrendingUp, Trash2, Truck, Undo2, Unlock, Upload,
        User, UserPlus, Users, Volume2, VolumeX, Wifi, Wrench, X, Zap,
        Anchor, Ban, Bell, BriefcaseMedical, Cable, CalendarClock, CircleCheck, ClipboardCheck, ClipboardPen, Cog, DoorOpen, DraftingCompass, ExternalLink,
        FileCheck, FileSearch, FileSpreadsheet, Gauge, Hourglass, Lightbulb, ListChecks, QrCode, Paperclip, ScanBarcode, ScanLine, ShieldAlert, Siren,
      })
    ),
    {
      provide: APP_INITIALIZER,
      useFactory: (versionService: VersionService) => () => versionService.checkVersion(),
      deps: [VersionService],
      multi: true
    }
  ]
})
  .catch(err => console.error(err));
